import React from 'react';
import Facebook from 'assets/svg/facebook-icon.svg';
import Instagram from 'assets/svg/instagram-icon.svg';
import Linkedin from 'assets/svg/linkedin-icon.svg';
import Tiktok from 'assets/svg/tiktok-icon.svg';
import Twitter from 'assets/svg/twitter-icon.svg';
import { Link } from 'gatsby';

interface SocialMediaLinks {
  instagramLink?: string;
  facebookLink?: string;
  twitterLink?: string;
  tiktokLink?: string;
  linkedinLink?: string;
}

export const SocialIcons = ({
  socialMediaLinks,
}: {
  socialMediaLinks: SocialMediaLinks;
}) => (
  <div className="social-icons">
    {socialMediaLinks && socialMediaLinks.instagramLink ? (
      <Link target="_blank" to={socialMediaLinks.instagramLink}>
        <Instagram />
      </Link>
    ) : null}
    {socialMediaLinks && socialMediaLinks.tiktokLink ? (
      <Link target="_blank" to={socialMediaLinks.tiktokLink}>
        <Tiktok />
      </Link>
    ) : null}
    {socialMediaLinks && socialMediaLinks.facebookLink ? (
      <Link target="_blank" to={socialMediaLinks.facebookLink}>
        <Facebook />
      </Link>
    ) : null}
    {socialMediaLinks && socialMediaLinks.twitterLink ? (
      <Link target="_blank" to={socialMediaLinks.twitterLink}>
        <Twitter />
      </Link>
    ) : null}

    {socialMediaLinks && socialMediaLinks.linkedinLink ? (
      <Link target="_blank" to={socialMediaLinks.linkedinLink}>
        <Linkedin />
      </Link>
    ) : null}
  </div>
);
